const registrationForm = [
  {
    label: "个人（团队）自荐",
    key: "selfRecommend",
    value: 0,
  },
  {
    label: "教育部直属高校及部省合建高校推荐",
    key: "recommendByMinistry",
    value: 1,
  },
  {
    label: "省级教育行政部门推荐",
    key: "recommendByProvince",
    value: 2,
  },
];

const registrationType = [
  {
    label: "个人",
    key: "individual",
    value: 0,
  },
  {
    label: "团队",
    key: "team",
    value: 1,
  },
];

const songType = [
  {
    label: "原创",
    key: "original",
    value: 0,
  },
  {
    label: "改编",
    key: "adaptation",
    value: 1,
  },
];

const audioType = [
  {
    label: "诵读作品",
    key: "recitation",
    value: 0,
  },
  {
    label: "创意音频",
    key: "creativeAudio",
    value: 1,
  },
  {
    label: "有声故事",
    key: "audioStory",
    value: 2,
  },
];

export default {
  registrationForm,
  registrationType,
  songType,
  audioType,
};
